import Loading from '@/components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initializeCsrfToken } from '../utils/auth';
import { getAndClearLoginInfoFromStorage } from '../utils/loginInfo';
import { apiPostRequest } from '../utils/apiClient';

const AuthCallback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const initializeSession = async () => {
            try {
                // CSRFトークンを初期化（明示的に取得）
                await initializeCsrfToken();

                // ログイン情報を取得してバックエンドに送信
                const loginInfo = getAndClearLoginInfoFromStorage();
                if (loginInfo) {
                    try {
                        await apiPostRequest('/api/auth/record-login-history', loginInfo);
                    } catch (error) {}
                }

                // トークン取得 or バックエンド確認済みならログイン成功とみなして遷移
                navigate('/desk');
            } catch (error) {
                // エラーが発生しても遷移を実行
                navigate('/desk');
            }
        };

        initializeSession();
    }, [navigate]);

    return <Loading />;
};

export default AuthCallback;
